import { render, staticRenderFns } from "./XzqhLxfs.vue?vue&type=template&id=6f0aa00c&scoped=true&"
import script from "./XzqhLxfs.vue?vue&type=script&lang=js&"
export * from "./XzqhLxfs.vue?vue&type=script&lang=js&"
import style0 from "./XzqhLxfs.vue?vue&type=style&index=0&id=6f0aa00c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0aa00c",
  null
  
)

export default component.exports